import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Home from './components/Home'
import About from './components/About'
import Layout from './components/Layout'
import CaseStudy from './components/CaseStudy'
import Infrastructure from './components/Infrastructure'
import NotFound from './components/NotFound'
import './App.scss'
import './components/Layout/style.css'
const Contact = lazy(() => import('./components/Contact'))
const Portfolio = lazy(() => import('./components/Portfolio'))
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="work/:slug" element={<CaseStudy />} />
        <Route path="infrastructure" element={<Infrastructure />} />
        <Route path="contact" element={<Contact />} />
        <Route
          path="dashboard"
          element={<Navigate to="/portfolio" replace />}
        />
        <Route path="blog" element={<Navigate to="/portfolio" replace />} />
        <Route
          path="youtubeVideosAndTwitchStreams"
          element={<Navigate to="/about" replace />}
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
